export const useFamilyOverviewStyles = (isSmallScreen) => {
    return {
        container: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        headerSection: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: (theme) => theme.spacing(1.5)
        },
        membersGrid: {
            height: isSmallScreen ? 'auto' : 'calc(100dvh - 235px)',
            overflow: 'auto'
        },
        activityContent: {
            display: 'flex',
            flexDirection: 'column',
            height: isSmallScreen ? 'auto' : 'calc(100dvh - 235px)',
            overflow: 'auto',
            gap: (theme) => theme.spacing(1.5)
        },
        emptyState: {
            fontSize: '16px',
            color: (theme) => theme.palette.grey[500],
            textAlign: 'center'
        }
    };
};
